import React from "react";
import { CanvasContext } from "./hooks/use-canvas-context";
import PropTypes from "prop-types";
import { PropTypes as CustomPropTypes } from "victory-core";

var CanvasGroup = function (props) {
  var canvasRef = React.useRef();
  var children = props.children,
      width = props.width,
      height = props.height,
      clipWidth = props.clipWidth,
      padding = props.padding;
  var clear = React.useCallback(function (ctx) {
    return ctx.clearRect(0, 0, width, height);
  }, [width, height]); // This needs to be called in the child component to ensure it is called after the
  // shape is drawn

  var clip = React.useCallback(function (ctx) {
    var maxClipWidth = width - padding.right - padding.left;
    ctx.clearRect(width - padding.right, 0, (maxClipWidth - clipWidth) * -1, height);
  }, [width, height, padding, clipWidth]);
  return /*#__PURE__*/React.createElement(CanvasContext.Provider, {
    value: {
      canvasRef: canvasRef,
      clear: clear,
      clip: clip
    }
  }, /*#__PURE__*/React.createElement("foreignObject", {
    width: width,
    height: height,
    x: 0,
    y: 0
  }, /*#__PURE__*/React.createElement("canvas", {
    width: width,
    height: height,
    ref: canvasRef
  })), children);
};

CanvasGroup.propTypes = {
  "aria-label": PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  className: PropTypes.string,
  clipWidth: CustomPropTypes.nonNegative,
  height: PropTypes.number,
  padding: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
    top: PropTypes.number,
    bottom: PropTypes.number,
    left: PropTypes.number,
    right: PropTypes.number
  })]),
  width: PropTypes.number
};
CanvasGroup.role = "container";
CanvasGroup.displayName = "CanvasGroup";
export default CanvasGroup;